<template>
  <v-dialog v-model="dialog" width="1024px" persistent>
    <v-card>
      <v-card-title class="mx-3">
        {{ $t("CRUD.chooseInfo", [$t("Material.ObjectName")]) }}
        <v-spacer />
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          <span>{{ $t("$vuetify.close") }}</span>
        </v-tooltip>
      </v-card-title>
      <v-row dense class="mx-5">
        <v-col cols="12" sm="6">
          <v-row dense align="center" class="pa-1">
            <SearcherKeyword
              ref="keyword"
              v-model="options.keyword"
              :label="$t('stockDetail.materialNameKeyword')"
            />
          </v-row>
        </v-col>
        <v-col cols="12" sm="6">
          <v-row dense align="center" class="pa-1">
            <SearcherKeyword
              ref="stock_in_order_code"
              v-model="options.stock_in_order_code"
              :label="$t('stockDetail.stockInOrderCode')"
            />
          </v-row>
        </v-col>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="materials"
        :loading="loading"
        multi-sort
        class="elevation-0 px-6"
        v-resize="resizeHeader"
        :footer-props="footerProps"
      >
        <template v-slot:header.choose>
          <v-checkbox
            class="mt-2 mb-n3"
            color="primary"
            :indeterminate="
              materials.find((detail) => detail.choose != chooseAll)
                ? true
                : false
            "
            v-model="chooseAll"
            :true-value="1"
            :false-value="0"
          >
            <template v-slot:label>
              <span class="caption ms-n2">
                {{ $t("CRUD.chooseAll") }}
              </span>
            </template>
          </v-checkbox>
        </template>
        <template v-slot:item.choose="{ item }">
          <div class="d-flex mt-n2 mb-n3">
            <v-checkbox
              color="primary"
              v-model="item.choose"
              :true-value="1"
              :false-value="0"
              :disabled="item.disabled"
            >
              <template v-slot:label>
                <span class="caption ms-n2">
                  {{ $t(item.choose ? "CRUD.choosed" : "CRUD.unchoose") }}
                </span>
              </template>
            </v-checkbox>
          </div>
        </template>

        <template v-slot:item.Description="{ item }">
          <span
            v-if="item.standard_name && item.standard_name.length > 12"
            :title="item.standard_name"
            style="cursor: pointer"
          >
            {{ item.Description }}
          </span>
          <span v-else>
            {{ item.Description }}
          </span>
        </template>
      </v-data-table>
      <v-card-actions>
        <span class="caption">
          {{ $t("CRUD.chooseCount", [choosedLength, newChoosedArr.length]) }}
        </span>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          outlined
          class="elevation-1"
          @click="dialog = false"
        >
          {{ $t("$vuetify.close") }}
        </v-btn>
        <v-btn color="accent" @click="saveChoose()">
          {{ $t("CRUD.confirm") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import StockDetails from "@/api/stock_details";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
const defaultOptions = {
  keyword: "",
  stock_in_order_code: "",
};

export default {
  name: "MaterialsSelectsDialog",

  props: {
    value: Boolean,
    changed: Array,
    materialIds: Array,
    disabledItems: Array,
  },

  components: {
    SearcherKeyword,
  },

  computed: {
    headers() {
      let header = [
        {
          text: i18n.t("stockDetail.Fields.material_category"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "category_name",
        },
        {
          text: i18n.t("stockDetail.Fields.material_name"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "Description",
        },
        {
          text: i18n.t("stockDetail.Fields.stock_batch_code"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "stock_batch_code",
        },
      ];
      if (
        this.accountSettings &&
        this.accountSettings.product_date_setting == 1
      ) {
        header.push(
          {
            text: i18n.t("stockDetail.Fields.production_date"),
            align: "start",
            sortable: false,
            filterable: true,
            value: "production_date",
          },
          {
            text: i18n.t("stockDetail.Fields.expired_date"),
            align: "start",
            sortable: false,
            filterable: true,
            value: "expired_date",
          }
        );
      }
      header.push(
        {
          text: i18n.t("stockDetail.Fields.return_stock_current"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "stock_current",
        },
        {
          text: i18n.t("CRUD.chooseAll"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "choose",
        }
      );
      return header;
    },

    footerProps() {
      return Object.assign({}, i18n.t("$config.footer-props"), {
        itemsPerPageOptions: [this.itemsPerPageOptions],
      });
    },

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "accountSettings"]),
  },

  data: () => ({
    dialog: false,
    materials: [],
    itemsPerPageOptions: 10,
    materialIdsChoosed: [],
    chooseAll: 0,
    newChoosedArr: [],
    choosedLength: 0,
    options: JSON.parse(JSON.stringify(defaultOptions)),
  }),

  methods: {
    resizeHeader() {
      this.itemsPerPageOptions = window.innerHeight > 800 ? 10 : 5;
    },

    //获取material列表
    getMaterialsFromAPI() {
      this.materialsLoading = true;
      let option = JSON.parse(JSON.stringify(this.options));
      StockDetails.getReturnList(option).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.materials = response.data.stock_details.map((details) => {
              details.Description = i18n.t(
                "Material.materialNameWithCodeAndStandard",
                [
                  details.material_code,
                  details.material_name,
                  details.standard_name && details.standard_name.length > 12
                    ? details.standard_name.slice(0, 12) + "......"
                    : details.standard_name,
                ]
              );
              // //默认勾选
              if (this.materialIdsChoosed.indexOf(details.id) > -1) {
                details = Object.assign({}, details, {
                  choose: 1,
                  disabled: true,
                });
              } else {
                if (details.choose == 1 || !details.choose) {
                  details.choose = 0;
                }
                if (details.disabled) {
                  details.disabled = false;
                }
              }
              return details;
            });
          }
        }.bind(this)
      );
    },

    saveChoose() {
      this.dialog = false;
      this.$emit("confirm", this.newChoosedArr);
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        if (this.value) {
          this.dialog = this.value;
          if (this.disabledItems && this.disabledItems.length) {
            this.materialIdsChoosed = this.disabledItems.map((item) => {
              return item.stock_detail_id;
            });
          } else {
            this.materialIdsChoosed = [];
          }
          this.choosedLength = this.materialIdsChoosed.length;
          this.getMaterialsFromAPI();
        }
      },
    },
    dialog: {
      handler() {
        if (!this.dialog) {
          this.newChoosedArr = [];
          this.options = JSON.parse(JSON.stringify(defaultOptions));
          this.chooseAll = false;
          this.materials = [];
        }
        this.$emit("input", this.dialog);
      },
    },
    chooseAll: {
      handler() {
        this.materials = this.materials.map(
          function (e) {
            var item = this.materials.find((m) => m.id == e.id);
            if (item && !item.disabled) e.choose = this.chooseAll ? 1 : 0;
            return e;
          }.bind(this)
        );
      },
    },
    materials: {
      deep: true,
      handler() {
        //整理新增商品
        this.materials.forEach((material) => {
          if (
            material.choose &&
            !this.materialIdsChoosed.includes(material.id) &&
            !this.newChoosedArr.find(
              (new_choosed) => new_choosed.id == material.id
            )
          ) {
            this.newChoosedArr.push(material);
            this.choosedLength = this.choosedLength + 1;
          } else if (
            !material.choose &&
            this.newChoosedArr.find(
              (new_choosed) => new_choosed.id == material.id
            )
          ) {
            this.newChoosedArr.splice(
              this.newChoosedArr.findIndex(
                (new_choosed) => new_choosed.id == material.id
              ),
              1
            );
            this.choosedLength = this.choosedLength - 1;
          }
        });
      },
    },
    options: {
      deep: true,
      handler() {
        this.getMaterialsFromAPI();
      },
    },
  },
};
</script>